import { isElectron } from "@/common/environment";
import { Main } from "@/desktop/events";

export function openExternal(url: string) {
  if (isElectron) {
    const { ipc } = window.AxureCloudNative;
    ipc.send(Main.OpenExternal, url);
  }
}
